import { PlanTaskReferencePickerPlugin } from '../types';

export const planTaskPluginMetadata = {
  domain: 'autodesk-construction-schedule',
  type: 'task',
} satisfies PlanTaskReferencePickerPlugin['metadata'];

export enum PlanTaskAnalyticEvent {
  ADD = 'schedule.plan.task.reference.add',
  DELETE = 'schedule.plan.task.reference.remove',
  VIEW = 'schedule.plan.task.reference.view',
}
